<mat-toolbar class="receipt-header-toolbar flex-row justify-start align-center gap-10">
  <mat-toolbar-row class="flex-row justify-start align-center">
    <div>
      <!-- button retour-->
      <app-back-button class="align-self-start"
                       [stopNavigation]="true"
                       (click)="onExit()"
                       [style]="{ padding: 0 }"></app-back-button>
    </div>
    <span class="receipt-header-toolbar-title">{{"RECEIPT.INNER_TITLE" | transloco}}</span>
  </mat-toolbar-row>
</mat-toolbar>
<div class="receipt-container">
  <app-receipt [order]="data"
               (exit)="onExit()"></app-receipt>
</div>
